var baseMenu = require('base/components/menu');
var keyboardAccessibility = require('base/components/keyboardAccessibility');

module.exports = function () {
    baseMenu();

    // Fix WCAG 2.1.2: Override base My Account dropdown keyboard handler
    // to prevent focus trap between first two list items
    $('.navbar-header .user').off('keydown');
    keyboardAccessibility('.navbar-header .user',
        {
            40: function ($popover) { // down arrow
                var $items = $popover.find('a');
                var $focused = $items.filter(':focus');
                var index = $items.index($focused);
                if (index < $items.length - 1) {
                    $items.eq(index + 1).focus();
                } else if (index === -1) {
                    $items.first().focus();
                }
            },
            38: function ($popover) { // up arrow
                var $items = $popover.find('a');
                var $focused = $items.filter(':focus');
                var index = $items.index($focused);
                if (index > 0) {
                    $items.eq(index - 1).focus();
                } else if (index === 0) {
                    $(this).focus();
                    $popover.removeClass('show');
                }
            },
            27: function () { // escape
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () { // tab
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            }
        },
        function () {
            return $('.user .popover');
        }
    );

    const SELECTORS = {
        body: 'body',
        orderInputContainer: '.input-group-wrapper',
        orderStatusMsg: '.js-order-status-msg',
        orderNoInput: '.js-input-order-number',
        orderTrackBtn: '.js-track-order-btn',
        navbarToggler: '.navbar-toggler',
        navbar: 'nav.navbar',
        dropdownMenu: '.dropdown-menu',
        mainMenu: 'nav.main-menu',
        closeMenuButton: '.close-menu button'
    }

    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on('mouseenter', function () {
            if (isDesktop(this)) {
                var leftOffset = (parseFloat($(this).siblings(SELECTORS.dropdownMenu).innerWidth() / 2) - parseFloat($(this).innerWidth()) / 2) * -1;
                $(this).siblings(SELECTORS.dropdownMenu)
                    .css('left', leftOffset);
            }
        });

    $(SELECTORS.navbarToggler).on('click', function () {
        $(SELECTORS.dropdownMenu).css('left', '-100%');
        $(SELECTORS.mainMenu).css('overflow', 'auto');
        $(SELECTORS.navbar).addClass('open');
    });

    $(SELECTORS.closeMenuButton).on('click', function() {
        $(SELECTORS.mainMenu).css('overflow', 'unset');
        $(SELECTORS.navbar).removeClass('open');
    })

    $(SELECTORS.body).on('keyup', SELECTORS.orderNoInput, function(e) {
        if (e.key === 'Enter') {
            $(SELECTORS.orderTrackBtn).trigger('click');
        }
    });

    $(SELECTORS.body).on('click', SELECTORS.orderTrackBtn, function(e) {
        let orderNumber = $(this).parent().siblings(SELECTORS.orderNoInput).val();
        let url = $(this).data('url');

        if (!orderNumber) {
            return;
        }

        var $container = $(this).parents(SELECTORS.orderInputContainer);
        e.preventDefault();
        $container.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {orderId: orderNumber.trim()},
            success: function (data) {
                $container.spinner().stop();
                $(SELECTORS.orderStatusMsg).html('<span class="p-2 d-block">' + data.message + '</span>');
            },
            error: function (err) {
                $container.spinner().stop();
                $(SELECTORS.orderStatusMsg).html('<span class="p-2 d-block">' + err.message + '</span>');
            }
        });

        return false;
    });
};
